site:
  title: Affiliates system
  lang: en
modals:
  login:
    title: Log in
    submitButton: Log in
    resetLink: Reset you password
    signUpLink: Register
    or: or
  reset:
    title: Forgot your password?
    submitButton: Reset Password
  signUp:
    title: Register
    submitButton: Register
    termsText: I accept the
    termsLink: Affiliate Terms & Conditions
  notVerified:
    title: You have registered successfully.
    text: We will review your application and, if your account is verified, you will be notified via email.
  terms:
    title: AFFILIATE TERMS & CONDITIONS
whyUs:
  title: WHY US?
  subtitle: 
  note: ""
  action:
    text: ""
  modifier: card--primary
  list:
    - id: whyus-1
      title: 24/7 Partner Support
      text: "Our affiliate managers are available whenever you need them. It doesn't matter if it's a campaign question or a technical issue - we're here to help you grow through whichever channel works best for you."
      image: headphones-fill
    - id: whyus-2
      title: A Casino Built for Nigeria
      text: "BIT9JA is designed for Nigerian players, with USDT and NGN payment support, crypto flexibility, and a game lobby built around what the market actually plays. That focus translates directly into better conversion and stronger retention for you."
      image: gamepad-fill
    - id: whyus-3
      title: Detailed, Real-Time Stats
      text: "Our affiliate platform gives you hourly updates and full visibility over your campaigns, traffic, and player activity — so you always know where you stand."
      image: chart-fill
    - id: whyus-4
      title: Fast Affiliate Payments
      text: We pay on time, every time. Payments are processed automatically once they have been reviewed and approved internally.
      image: wallet-fill
commission:
  title: Commission
  subtitle: Our tiered Revenue Share model starts at 15% and goes up to 30%. The more quality traffic you send, the more you earn.
  note: ""
  action:
    text: Become Our Partner
    modal: signup
    variant: button
    buttonVariant: primary
  button: Get Started
  variant: circular
  modifier: card--primary
  list:
    - title: of revenue share
      image: countries
      list:
        - "1"
      level: 1ST LEVEL
      percentage: 15
      range: 0 - 2,000 USDT
      id: 1763469684552_mb4d4cc4g
    - title: of revenue share
      image: stats
      list:
        - ""
      level: 2ND LEVEL
      percentage: 20
      range: 2,000 - 5,000 USDT
      id: 1763469684552_f6c4s5pc2
    - title: of revenue share
      image: wallet
      list:
        - ""
      level: 3RD LEVEL
      percentage: 25
      range: 5,000 - 10,000 USDT
      id: 1763469684552_mo2jxuc70
    - title: of revenue share
      image: wallet
      list: []
      level: 4TH LEVEL
      percentage: 30
      range: 10,000+ USDT
      id: 1763469684552_lst9i1xuq
faq:
  title: FAQ
  subtitle: ""
  note: ""
  action:
    text: Affiliate Program Terms & Conditions
    modal: terms
  list:
    - id: section-1
      question: What is BIT9JA Partners?
      answer: BIT9JA Partners is the official affiliate program of BIT9JA Casino. We offer competitive revenue share plans, real-time reporting, and dedicated support to help our partners grow their business.
      type: text
    - id: section-2
      question: How do I become a partner?
      answer: Simply click "Join Now", complete the registration form, and our team will review your application. Once approved, you'll get instant access to your affiliate dashboard.
      type: text
    - id: section-3
      question: What affiliate software do you use?
      answer: We use industry-leading affiliate tracking software to ensure accurate reporting and reliable attribution across all your campaigns.
      type: text
    - id: section-4
      question: How do I get in touch?
      answer: You can reach our affiliate team directly through the contact form on this page, or drop us an email at partners@bit9ja.com or affiliates@bit9ja.com. We'll get back to you promptly.
      type: text
    - id: section-5
      question: How much does it cost to join?
      answer: Nothing. Joining BIT9JA Partners is completely free.
      type: text
    - id: section-6
      question: How much will I earn?
      answer: Your earnings depend on the volume and quality of traffic you send. Our tiered Revenue Share model starts at 15% and goes up to 30%.
      type: text
contacts:
  title: Contacts
  subtitle: ""
  note: ""
  action:
    text: ""
  list:
    - id: contact-1
      type: email
      href: "mailto:partners@bit9ja.com"
      text: partners@bit9ja.com
      icon: envelope-fill
      alt: Email icon
    - id: contact-2
      type: email
      href: "mailto:affiliates@bit9ja.com"
      text: affiliates@bit9ja.com
      icon: envelope-fill
      alt: Email icon
hero:
  title: BIT9JA Partners Program
  subtitle: Join the
  text: BIT9JA Partners is the affiliate program built for those who know the Nigerian market. Promote one of Nigeria's fastest-growing crypto casinos and earn competitive commissions on every player you bring in. Reliable payouts, real support, and a brand that players actually come back to.
  action:
    text: Join now
    modal: signup
    variant: button
  image: banner
  imageMobile: banner-mob
footer:
  copyright: © 2026 BIT9JA Partners | All rights reserved
settings:
  showMenu: true
  showHero: true
  showWhyUs: true
  showCommission: true
  showTestimonials: true
  showFaq: true
  showContacts: true
  logoPath: /logo.webp
  logoSmallPath: /logo-small.webp
metadata:
  title: Affiliates system
  description: Affiliates system
  keywords: casino affiliate, affiliate program, revenue share, CPA, hybrid deals, gambling affiliate
  author: BIT9JA Partners
  robots: index, follow
